// components/Loading.js
const Loading = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="spinner-border text-primary" role="status" />
  </div>
);

export default Loading;
